import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';


const Dot = styled.div`
    position: relative;
    width: 30%;
    height: 60%;
    margin:0;
    opacity: 0;
    animation: showHideDot 2.5s ease-in-out infinite;
    @keyframes showHideDot {
      0% { 
        opacity: 1;
       }
      25% { 
        opacity: 0.6; 
      }
      50% {
        opacity: 0.2; 
       }
      
      25% { 
        opacity: 0.6; 
      }
      100% { 
        opacity: 1; 
      }
    }
`;

const DotsContainer = styled.div`
  position: relative;
  font-size: 1vh;
  display: flex;
  justify-content: space-between ;
  align-items: flex-end;
  left: 2vh;
  width: 8vw;
  height: 70%;
`;


export const AnimatedEllipsis = () => <DotsContainer>
  <Dot css={css`animation-delay: 0.2s`}>⬤</Dot>
  <Dot css={css`animation-delay: 0.5s`}>⬤</Dot>
  <Dot css={css`animation-delay: 0.8s`}>⬤</Dot>
</DotsContainer>;

